import React from "react";
import { Route, Navigate } from "react-router-dom";
import Marketing from "../pages/Marketing";
import AdInventoryPricing from "../pages/AdInventoryPricing";
import PromotionsManagement from "../pages/PromotionsManagement";
import PromotionOptInsView from "../pages/PromotionOptInsView";
import VendorPromotions from "../pages/VendorPromotions";
import PromotionOptIn from "../pages/PromotionOptIn";
import AdminCampaignsDashboard from "../pages/AdminCampaignsDashboard";
import AuctionLogsPage from "../pages/AuctionLogsPage";
import UniversalCampaignBuilder from "../pages/UniversalCampaignBuilder";
import CreateCampaign from "../pages/CreateCampaign";
import Offers from "../pages/Offers";
import CreateOffer from "../pages/CreateOffer";

/**
 * Marketing, campaigns, promotions, and offers routes.
 */
export const MarketingRoutes = ({ PrivateRoute, ProtectedRoute }) => (
  <>
    <Route path="/offers" element={<PrivateRoute><Offers /></PrivateRoute>} />
    <Route path="/offers/new" element={<PrivateRoute><CreateOffer /></PrivateRoute>} />
    <Route path="/offers/edit/:id" element={<PrivateRoute><CreateOffer /></PrivateRoute>} />
    <Route path="/marketing" element={<PrivateRoute><Marketing /></PrivateRoute>} />
    <Route path="/marketing/ad-inventory" element={<PrivateRoute requiredPermission="manage_marketing"><AdInventoryPricing /></PrivateRoute>} />
    <Route path="/marketing/promotions" element={<PrivateRoute requiredPermission="manage_marketing"><PromotionsManagement /></PrivateRoute>} />
    <Route path="/marketing/promotions/:promotionId/opt-ins" element={<PrivateRoute requiredPermission="manage_marketing"><PromotionOptInsView /></PrivateRoute>} />
    <Route path="/promotions" element={<PrivateRoute><VendorPromotions /></PrivateRoute>} />
    <Route path="/promotions/:promotionId/opt-in" element={<PrivateRoute><PromotionOptIn /></PrivateRoute>} />
    <Route path="/marketing/campaigns" element={<PrivateRoute requiredPermission="view_marketing"><AdminCampaignsDashboard /></PrivateRoute>} />
    <Route path="/marketing/auction-logs" element={<PrivateRoute requiredPermission="manage_marketing"><AuctionLogsPage /></PrivateRoute>} />
    <Route path="/marketing/builder" element={<PrivateRoute><UniversalCampaignBuilder /></PrivateRoute>} />
    {/* Legacy routes redirect to unified campaign builder */}
    <Route path="/marketing/email" element={<PrivateRoute><Navigate to="/marketing/builder?channel=email" replace /></PrivateRoute>} />
    <Route path="/marketing/sms" element={<PrivateRoute><Navigate to="/marketing/builder?channel=sms" replace /></PrivateRoute>} />
    <Route path="/marketing/whatsapp" element={<PrivateRoute><Navigate to="/marketing/builder?channel=whatsapp" replace /></PrivateRoute>} />
    <Route path="/create-campaign" element={<ProtectedRoute permission="create_campaigns"><CreateCampaign /></ProtectedRoute>} />
  </>
);
